export const concentData = {
    maxicus: {
      text: ` <div id="container">
      <table>
          <tr>
              <td>
                <table width="100%" class="header">
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td style="padding-left:1rem;width: 215px">
                                  <div style="width: 100%;display: flex;justify-content: center;">           
                                      <div style="width: 170px;height: 60px;">
                                          <img style="width: 100%;height: 100%;object-fit: contain;" id="logo" src="https://maxicus.com/mailer/maxicus.png"/>
                                      </div>
                                  </div>
                              </td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:20px;font-weight:bold;padding:1rem 0;margin-top: 0;">Maxicus Technologies Pvt. Ltd.
                                </h1>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:1.5rem;font-weight:700;padding:1rem 0;margin-top: 0;">
                                  Onboarding Consent
                                </h1>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          As part of the onboarding process at Maxicus, we
                          require certain personal information from you to
                          facilitate your employment. This information includes, but
                          is not limited to, details such as your PAN card, Aadhar
                          card, education history, former employment details, and
                          references. Additionally, background verification may be
                          conducted, encompassing your physical address, criminal
                          history, and employment background.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Background verification may include checks on your
                          physical address, criminal history, and employment
                          background. Please be assured that such verification will
                          be conducted in compliance with applicable laws and
                          regulations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By proceeding with the onboarding process, you hereby
                          consent to the collection, processing, and retention of
                          these specific personal details by Maxicus for the
                          duration of your employment and as required by law. Your
                          information will be treated with the utmost
                          confidentiality and will only be used for legitimate
                          business purposes associated with your employment,
                          including payroll, benefits administration, and compliance
                          with legal obligations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Maxicus is committed to protecting your privacy and
                          ensuring the security of your personal information. We
                          will not disclose, share, or sell your information to any
                          unauthorized third parties.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By completing the onboarding process, you acknowledge that
                          you have read and understood the terms of this onboarding
                          consent disclaimer.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          If you have any questions or require further
                          clarification, please contact your HR department or
                          designated contact.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Thank you for joining Maxicus.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 25px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Name</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                          style="border-bottom: 1px solid black;min-width: 250px;"
                          id="name_1"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Date</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                        style="border-bottom: 1px solid black;min-width: 250px"
                          id="date_of_joining"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong> Signature</strong>
                      </td>
                      <td
                        style="
                          padding-top: 10px;
                          width: 70%;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem"
                        >
                        <strong>:</strong>
                        <div class="sig">
                          <img
                            id="signature"
                            src=""
                            alt="signature"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
      </table>
  </div>`,
    },
    kochar: {
      text : `   <div id="container">
      <table>
          <tr>
              <td>
                <table width="100%" class="header">
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td style="padding-left:1rem;width: 215px">
                                  <div style="width: 100%;display: flex;justify-content: center;">           
                                      <div style="width: 170px;height: 60px;">
                                          <img style="width: 100%;height: 100%;object-fit: contain;" id="logo" src="https://maxicus.com/mailer/kochar_hiring.png"/>
                                      </div>
                                  </div>
                              </td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:20px;font-weight:bold;padding:1rem 0;margin-top: 0;">KOCHAR INFOTECH Pvt. LTD.
                                </h1>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:1.5rem;font-weight:700;padding:1rem 0;margin-top: 0;">
                                  Onboarding Consent
                                </h1>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          As part of the onboarding process at KocharTech, we
                          require certain personal information from you to
                          facilitate your employment. This information includes, but
                          is not limited to, details such as your PAN card, Aadhar
                          card, education history, former employment details, and
                          references. Additionally, background verification may be
                          conducted, encompassing your physical address, criminal
                          history, and employment background.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Background verification may include checks on your
                          physical address, criminal history, and employment
                          background. Please be assured that such verification will
                          be conducted in compliance with applicable laws and
                          regulations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By proceeding with the onboarding process, you hereby
                          consent to the collection, processing, and retention of
                          these specific personal details by KocharTech for the
                          duration of your employment and as required by law. Your
                          information will be treated with the utmost
                          confidentiality and will only be used for legitimate
                          business purposes associated with your employment,
                          including payroll, benefits administration, and compliance
                          with legal obligations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          KocharTech is committed to protecting your privacy and
                          ensuring the security of your personal information. We
                          will not disclose, share, or sell your information to any
                          unauthorized third parties.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By completing the onboarding process, you acknowledge that
                          you have read and understood the terms of this onboarding
                          consent disclaimer.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          If you have any questions or require further
                          clarification, please contact your HR department or
                          designated contact.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Thank you for joining KocharTech.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 25px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Name</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                          style="border-bottom: 1px solid black;min-width: 250px;"
                          id="name_1"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Date</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                        style="border-bottom: 1px solid black;min-width: 250px"
                          id="date_of_joining"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong> Signature</strong>
                      </td>
                      <td
                        style="
                          padding-top: 10px;
                          width: 70%;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem"
                        >
                        <strong>:</strong>
                        <div class="sig">
                          <img
                            id="signature"
                            src=""
                            alt="signature"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
      </table>
  </div>`
    },
    igzy: {
      text:` <div id="container">
      <table>
          <tr>
              <td>
                <table width="100%" class="header">
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td style="padding-left:1rem;width: 215px">
                                  <div style="width: 100%;display: flex;justify-content: center;">           
                                      <div style="width: 170px;height: 60px;">
                                          <img style="width: 100%;height: 100%;object-fit: contain;" id="logo" src="https://maxicus.com/mailer/igzy_hiring.png"/>
                                      </div>
                                  </div>
                              </td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:20px;font-weight:bold;padding:1rem 0;margin-top: 0;">IGZY TECHNOLOGIES PVT. LTD.
                                </h1>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:1.5rem;font-weight:700;padding:1rem 0;margin-top: 0;">
                                  Onboarding Consent
                                </h1>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          As part of the onboarding process at Igzy, we
                          require certain personal information from you to
                          facilitate your employment. This information includes, but
                          is not limited to, details such as your PAN card, Aadhar
                          card, education history, former employment details, and
                          references. Additionally, background verification may be
                          conducted, encompassing your physical address, criminal
                          history, and employment background.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Background verification may include checks on your
                          physical address, criminal history, and employment
                          background. Please be assured that such verification will
                          be conducted in compliance with applicable laws and
                          regulations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By proceeding with the onboarding process, you hereby
                          consent to the collection, processing, and retention of
                          these specific personal details by Igzy for the
                          duration of your employment and as required by law. Your
                          information will be treated with the utmost
                          confidentiality and will only be used for legitimate
                          business purposes associated with your employment,
                          including payroll, benefits administration, and compliance
                          with legal obligations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Igzy is committed to protecting your privacy and
                          ensuring the security of your personal information. We
                          will not disclose, share, or sell your information to any
                          unauthorized third parties.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By completing the onboarding process, you acknowledge that
                          you have read and understood the terms of this onboarding
                          consent disclaimer.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          If you have any questions or require further
                          clarification, please contact your HR department or
                          designated contact.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Thank you for joining Igzy.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 25px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Name</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                          style="border-bottom: 1px solid black;min-width: 250px;"
                          id="name_1"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Date</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                        style="border-bottom: 1px solid black;min-width: 250px"
                          id="date_of_joining"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong> Signature</strong>
                      </td>
                      <td
                        style="
                          padding-top: 10px;
                          width: 70%;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem"
                        >
                        <strong>:</strong>
                        <div class="sig">
                          <img
                            id="signature"
                            src=""
                            alt="signature"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
      </table>
  </div>`,
    },
    kochiva: {
      text : ` <div id="container">
      <table>
          <tr>
              <td>
                <table width="100%" class="header">
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td style="padding-left:1rem;width: 215px">
                                  <div style="width: 100%;display: flex;justify-content: center;">           
                                      <div style="width: 170px;height: 60px;">
                                          <img style="width: 100%;height: 100%;object-fit: contain;" id="logo" src="https://maxicus.com/mailer/kochiva_hiring.png"/>
                                      </div>
                                  </div>
                              </td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:20px;font-weight:bold;padding:1rem 0;margin-top: 0;">Kochiva Pvt. Ltd.
                                </h1>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:1.5rem;font-weight:700;padding:1rem 0;margin-top: 0;">
                                  Onboarding Consent
                                </h1>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          As part of the onboarding process at Kochiva, we
                          require certain personal information from you to
                          facilitate your employment. This information includes, but
                          is not limited to, details such as your PAN card, Aadhar
                          card, education history, former employment details, and
                          references. Additionally, background verification may be
                          conducted, encompassing your physical address, criminal
                          history, and employment background.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Background verification may include checks on your
                          physical address, criminal history, and employment
                          background. Please be assured that such verification will
                          be conducted in compliance with applicable laws and
                          regulations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By proceeding with the onboarding process, you hereby
                          consent to the collection, processing, and retention of
                          these specific personal details by Kochiva for the
                          duration of your employment and as required by law. Your
                          information will be treated with the utmost
                          confidentiality and will only be used for legitimate
                          business purposes associated with your employment,
                          including payroll, benefits administration, and compliance
                          with legal obligations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Kochiva is committed to protecting your privacy and
                          ensuring the security of your personal information. We
                          will not disclose, share, or sell your information to any
                          unauthorized third parties.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By completing the onboarding process, you acknowledge that
                          you have read and understood the terms of this onboarding
                          consent disclaimer.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          If you have any questions or require further
                          clarification, please contact your HR department or
                          designated contact.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Thank you for joining Kochiva.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 25px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Name</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                          style="border-bottom: 1px solid black;min-width: 250px;"
                          id="name_1"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Date</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                        style="border-bottom: 1px solid black;min-width: 250px"
                          id="date_of_joining"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong> Signature</strong>
                      </td>
                      <td
                        style="
                          padding-top: 10px;
                          width: 70%;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem"
                        >
                        <strong>:</strong>
                        <div class="sig">
                          <img
                            id="signature"
                            src=""
                            alt="signature"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
      </table>
  </div>`,
    },
    kocharsoft: {
      text: ` <div id="container">
      <table>
          <tr>
              <td>
                <table width="100%" class="header">
                  <tbody>
                    <tr>
                      <td>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td style="padding-left:1rem;width: 215px">
                                  <div style="width: 100%;display: flex;justify-content: center;">           
                                      <div style="width: 170px;height: 60px;">
                                          <img style="width: 100%;height: 100%;object-fit: contain;" id="logo" src="https://maxicus.com/mailer/kocharsoft_hiring.png"/>
                                      </div>
                                  </div>
                              </td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:20px;font-weight:bold;padding:1rem 0;margin-top: 0;">KOCHAR INNOVATION PVT LTD.
                                </h1>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <h1
                                  style="text-align:center;font-size:1.5rem;font-weight:700;padding:1rem 0;margin-top: 0;">
                                  Onboarding Consent
                                </h1>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          As part of the onboarding process at Kochar Innovation, we
                          require certain personal information from you to
                          facilitate your employment. This information includes, but
                          is not limited to, details such as your PAN card, Aadhar
                          card, education history, former employment details, and
                          references. Additionally, background verification may be
                          conducted, encompassing your physical address, criminal
                          history, and employment background.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Background verification may include checks on your
                          physical address, criminal history, and employment
                          background. Please be assured that such verification will
                          be conducted in compliance with applicable laws and
                          regulations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By proceeding with the onboarding process, you hereby
                          consent to the collection, processing, and retention of
                          these specific personal details by Kochar Innovation for the
                          duration of your employment and as required by law. Your
                          information will be treated with the utmost
                          confidentiality and will only be used for legitimate
                          business purposes associated with your employment,
                          including payroll, benefits administration, and compliance
                          with legal obligations.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          Kochar Innovation is committed to protecting your privacy and
                          ensuring the security of your personal information. We
                          will not disclose, share, or sell your information to any
                          unauthorized third parties.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          By completing the onboarding process, you acknowledge that
                          you have read and understood the terms of this onboarding
                          consent disclaimer.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          If you have any questions or require further
                          clarification, please contact your HR department or
                          designated contact.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>Thank you for joining Kochar Innovation.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 25px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Name</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                          style="border-bottom: 1px solid black;min-width: 250px;"
                          id="name_1"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong>Date</strong>
                      </td>
                      <td style="padding-top: 10px; width: 70%">
                        <strong>:</strong>
                        <span
                        style="border-bottom: 1px solid black;min-width: 250px"
                          id="date_of_joining"
                          class="space">
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-top: 10px; width: 30%">
                        <strong> Signature</strong>
                      </td>
                      <td
                        style="
                          padding-top: 10px;
                          width: 70%;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem"
                        >
                        <strong>:</strong>
                        <div class="sig">
                          <img
                            id="signature"
                            src=""
                            alt="signature"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
      </table>
  </div>`,
    },
  }